(function () {
  var TK = window.TKCatalog || { categories: [], models: [], conditions: {} };

  if (!Array.isArray(window.DEVICES) || window.DEVICES.length === 0) {
    window.DEVICES = TK.models || [];
  }

  window.DEVICE_CONDITIONS = [
    { id: "New",      label: "Brand New", grade: "BN", sort: 1 },
    { id: "Like New", label: "Like New",  grade: "LN", sort: 2 },
    { id: "Working",  label: "Working",   grade: "WK", sort: 3 },
    { id: "Dead",     label: "Dead",      grade: "DD", sort: 4 }
  ];

  window.tkGetConditionsFor = function (brandSlug, deviceSlug) {
    var key = (brandSlug || "") + "|" + (deviceSlug || "");
    var conds = (TK.conditions && TK.conditions[key]) || [];
    if (conds.length === 0) return window.DEVICE_CONDITIONS;
    return conds.map(function (c) {
      return {
        id: c.name,
        label: c.name,
        sort: c.sort || 0,
        reusely_id: c.id,
        terms: c.terms || null,
        questions: c.questions || [],
        is_recycle: !!c.is_recycle
      };
    });
  };

  window.DEVICE_GATE = { required: [] };
  window.DEVICE_TYPES = [
    { id: "phone",   label: "Smartphones", icon: "phone"  },
    { id: "tablet",  label: "Tablets",     icon: "tablet" },
    { id: "laptop",  label: "Mac",         icon: "laptop" },
    { id: "console", label: "Game Systems", icon: "console" }
  ];

  window.TK_TYPE_CATEGORY = {
    phone:   "smartphones",
    tablet:  "tablets",
    laptop:  "mac",
    console: "game-systems"
  };
})();
